import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useTheme from '@mui/material/styles/useTheme';

import {usePasswordRequirements} from 'presentation/pages/public/hooks';

export function PasswordStrengthBar() {
	const {palette} = useTheme();
	const {isFieldDirty, progress, progressColor, progressText} = usePasswordRequirements();

	const color = isFieldDirty ? progressColor : 'inherit';

	return (
		<Stack spacing={1} color={palette.action.active}>
			<LinearProgress variant="determinate" value={progress} color={color} />
			{isFieldDirty && (
				<Typography variant="caption" color={color}>
					{progressText}
				</Typography>
			)}
		</Stack>
	);
}
